export class ReportDetail{
    public ID:number;
    public ReportName:string;
    public ReportSummary:string = '';
    constructor(values: Object = {}) {
        Object.assign(this, values);}
}